// @flow

export type Country =
  | 'br'
  | 'mx'
  | 'ar'
  | 'co'
  | 'cl'
  | 'pe'
  | 'ec'
  | 'bo'
  | 'uy'
  | 'py'
  | 'cr'
  | 'pa'
  | 'gt'
  | 'sv'
  | 'do'
  | 'za'
  | 'ke'
  | 'ng'
  | 'in'
  | 'tz'
  | 'ug'
  | 'zm'
  | 'eg'
  | 'gh'
  | 'jm'
  ;

export type CountryNationality =
  | 'brazilian'
  | 'mexican'
  | 'argentine'
  | 'colombian'
  | 'chilean'
  | 'peruvian'
  | 'ecuadorian'
  | 'bolivian'
  | 'uruguayan'
  | 'paraguayan'
  | 'costaRican'
  | 'panamanian'
  | 'guatemalan'
  | 'elSalvador'
  | 'dominican'
  | 'southAfrican'
  | 'kenyan'
  | 'nigerian'
  | 'india'
  | 'tanzanian'
  | 'uganda'
  | 'zambia'
  | 'egypt'
  | 'ghana'
  | 'jamaican'
  ;

export function getCountryNationality(country: Country): CountryNationality {
  switch (country) {
    case 'br': return 'brazilian';
    case 'mx': return 'mexican';
    case 'ar': return 'argentine';
    case 'co': return 'colombian';
    case 'cl': return 'chilean';
    case 'pe': return 'peruvian';
    case 'ec': return 'ecuadorian';
    case 'bo': return 'bolivian';
    case 'uy': return 'uruguayan';
    case 'py': return 'paraguayan';
    case 'cr': return 'costaRican';
    case 'pa': return 'panamanian';
    case 'gt': return 'guatemalan';
    case 'sv': return 'elSalvador';
    case 'do': return 'dominican';
    case 'za': return 'southAfrican';
    case 'ke': return 'kenyan';
    case 'ng': return 'nigerian';
    case 'in': return 'india';
    case 'tz': return 'tanzanian';
    case 'ug': return 'uganda';
    case 'zm': return 'zambia';
    case 'eg': return 'egypt';
    case 'gh': return 'ghana';
    case 'jm': return 'jamaican';
    default:
      throw new Error(`getCountryNationality: country "${country}" has no nationality mapped`);
  }
}
